// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"9eeae30f","839":"f40ba141"}[chunkId] + ".chunk.js";
};